import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import adminStorage from '../../utils/adminStorage';

const AuthWrapper = ({ children }) => {
    const [showKycBanner, setShowKycBanner] = useState(false);
    const [kycStatus, setKycStatus] = useState(null);

    const location = useLocation();
    const navigate = useNavigate();

    // Get user type and details
    function getPanelTypeAndDetails() {
        const agency = JSON.parse(sessionStorage.getItem("agency") || "null");
        const agencyadmin = JSON.parse(sessionStorage.getItem("agencyadmin") || "null");
        const bd = JSON.parse(sessionStorage.getItem("bd") || "null");
        const coin = JSON.parse(sessionStorage.getItem("coin") || "null");
        if (agency) return { type: "agency", details: agency };
        if (agencyadmin) return { type: "agencyadmin", details: agencyadmin };
        if (bd) return { type: "bd", details: bd };
        if (coin) return { type: "coin", details: coin };
        return { type: "admin", details: JSON.parse(adminStorage.getItem("data") || "null") };
    }

    const { type: forType, details: panelDetails } = getPanelTypeAndDetails();

    useEffect(() => {
        const fetchKyc = async () => {
            if (
                forType === "admin" ||
                location.pathname.includes(`/${forType}/submitKyc`)
            ) return;

            try {
                const res = await axios.get(`${process.env.REACT_APP_BASEURL1}/agency/myKycStatus`, {
                    params: { agencyCode: panelDetails?.uniqueId, forType },
                });

                if (res.data.success) {
                    setKycStatus(res.data.status);
                    if (res.data.status === "rejected" || res.data.status === "no_kyc") {
                        setShowKycBanner(true);
                        // navigate(`${forType}/submitKyc`)
                    }
                }
            } catch (e) {
                console.error("Failed to fetch KYC status", e);
            }
        };

        fetchKyc();
    }, [location.pathname, forType, panelDetails?.uniqueId]);

    return (
        <>
            {showKycBanner && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        backgroundColor: "#ff4d4f",
                        color: "#fff",
                        padding: "10px 20px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        zIndex: 1040,
                        animation: "slideDown 0.5s ease-out",
                    }}
                >
                    <div>
                        <strong>KYC Required:</strong> Please upload your KYC details to continue.
                    </div>
                    <div style={{ display: "flex", gap: "14px" }}>
                        <button
                            onClick={() => navigate(`/${forType}/submitKyc`)}
                            style={{
                                backgroundColor: "#fff",
                                color: "#ff4d4f",
                                border: "none",
                                padding: "5px 10px",
                                borderRadius: "4px",
                                cursor: "pointer",
                            }}
                        >
                            Upload KYC
                        </button>
                        <span
                            onClick={() => setShowKycBanner(false)}
                            style={{
                                cursor: "pointer",
                                fontSize: "18px",
                                fontWeight: "bold",
                            }}
                        >
                            ×
                        </span>
                    </div>
                </div>
            )}

            <div style={{ marginTop: showKycBanner ? "60px" : 0 }}>{children}</div>

            {/* Banner slide-down animation */}
            <style>
                {`
                @keyframes slideDown {
                    0% { transform: translateY(-100%); opacity: 0; }
                    100% { transform: translateY(0); opacity: 1; }
                }
                `}
            </style>
        </>
    );
};

export default AuthWrapper;
